import Confirmation from '../components/ScheduleRooms/Confirmation'

let routes = {
  path: '/confirmation',
  component: resolve => require(['../components/layout/Confirmation'], resolve),
  children: [
    {
      path: '/confirmation/:hash?',
      name: 'Confirmação de Presença',
      component: Confirmation
    },
  ]
}

export default routes



// WEBPACK FOOTER //
// ./src/router/confirmation.js